Drupal.behaviors.utilityPopup = {
  attach(context) {
    const popup = document.getElementById('block-itonic-webform-popup');
    if (!popup || popup.dataset.utilityPopupInitialized === 'true') {
      return;
    }

    // Ensure duplicate webform IDs in the popup are encountered first by Drupal AJAX.
    if (popup.parentElement !== document.body) {
      document.body.prepend(popup);
    }

    popup.dataset.utilityPopupInitialized = 'true';

    const closeButton = popup.querySelector('.contact-us-form__close');
    const overlay = popup.querySelector('.contact-us-popup__overlay');
    const popupFormContainer = popup.querySelector('.contact-us-form');
    const popupPrimaryForm = popupFormContainer ? popupFormContainer.querySelector('form') : null;
    const openLinks = document.querySelectorAll('a[href*="#popup-contact"]');
    const body = document.body;
    let popupOwnsScrollLock = false;
    let previousOverflow = '';
    let previousPaddingRight = '';

    const lockBodyScroll = () => {
      if (body.dataset.utilityPopupScrollLock === 'true') {
        return;
      }

      // Respect global locks owned by other UI controls (e.g. mobile nav).
      if (body.dataset.scrollLocked === 'true') {
        body.dataset.utilityPopupScrollLock = 'true';
        return;
      }

      previousOverflow = body.style.overflow;
      previousPaddingRight = body.style.paddingRight;

      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
      if (scrollBarWidth > 0) {
        body.style.paddingRight = `${scrollBarWidth}px`;
      }

      body.style.overflow = 'hidden';
      popupOwnsScrollLock = true;
      body.dataset.utilityPopupScrollLock = 'true';
    };

    const unlockBodyScroll = () => {
      if (body.dataset.utilityPopupScrollLock !== 'true') {
        return;
      }

      if (popupOwnsScrollLock) {
        body.style.overflow = previousOverflow;
        body.style.paddingRight = previousPaddingRight;
      }

      popupOwnsScrollLock = false;
      body.dataset.utilityPopupScrollLock = 'false';
    };

    const disableOutsideMatchingForms = () => {
      if (!popupPrimaryForm) {
        return;
      }

      const popupFormAction = popupPrimaryForm.getAttribute('action') || '';
      const popupFormIdValue = popupPrimaryForm.querySelector('input[name="form_id"]')?.value || '';

      document.querySelectorAll('form.webform-submission-form').forEach((form) => {
        if (popup.contains(form)) {
          return;
        }

        const formAction = form.getAttribute('action') || '';
        const formIdValue = form.querySelector('input[name="form_id"]')?.value || '';
        const isMatch = (popupFormIdValue && formIdValue === popupFormIdValue)
          || (popupFormAction && formAction === popupFormAction);

        if (!isMatch) {
          return;
        }

        form.querySelectorAll('input, select, textarea, button').forEach((field) => {
          if (!field.disabled) {
            field.disabled = true;
            field.dataset.utilityPopupDisabledByOverlay = 'true';
          }
        });
      });
    };

    const restoreOutsideMatchingForms = () => {
      document
        .querySelectorAll('input[data-utility-popup-disabled-by-overlay="true"], select[data-utility-popup-disabled-by-overlay="true"], textarea[data-utility-popup-disabled-by-overlay="true"], button[data-utility-popup-disabled-by-overlay="true"]')
        .forEach((field) => {
          field.disabled = false;
          delete field.dataset.utilityPopupDisabledByOverlay;
        });
    };

    const openPopup = () => {
      lockBodyScroll();
      disableOutsideMatchingForms();
      popup.classList.add('is-visible');
    };

    const closePopup = () => {
      popup.classList.remove('is-visible');
      restoreOutsideMatchingForms();
      unlockBodyScroll();
    };

    const clearPopupHash = () => {
      if (window.location.hash === '#popup-contact') {
        window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
      }
    };

    if (closeButton) {
      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        closePopup();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', () => {
        closePopup();
      });
    }

    openLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        openPopup();
        clearPopupHash();
      });
    });
  },
};
